<template>
  <div id="admin_users">
    <v-data-table
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      :headers="headers"
      :items="items"
      :search="search_form"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50, 100],
      }"
      :items-per-page="20"
      class="elevation-1"
    >
      <template v-slot:[`item.action`]="{ item }">
        <v-icon
          v-if="item.permissions.change"
          small
          class="mr-3"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="item.permissions.change"
          small
          class="mr-3"
          @click="historyItem(item)"
        >
          mdi-account-badge-outline
        </v-icon>
        <!-- <v-icon small color="red" @click="deleteItem(item)">mdi-delete</v-icon> -->
      </template>

      <template v-slot:[`item.is_active`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon
              v-if="item.is_active"
              class="mr-1"
              v-on="on"
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              class="mr-1"
              v-on="on"
            >
              mdi-close
            </v-icon>
          </template>
          <span v-if="item.is_active">Aktívny</span>
          <span v-else>Deaktivovaný</span>
        </v-tooltip>
      </template>

      <template v-slot:top>
        <!-- <v-subheader>Zoznam Používateľov</v-subheader>
        <v-divider></v-divider> -->
        <v-layout class="pa-3">
          <v-text-field
            v-model="search_form"
            label="Vyhľadať"
          />
          <v-switch
            v-model="my_only"
            class="pl-5"
            label="Iba mnou vytvorení"
          />
        </v-layout>
      </template>
    </v-data-table>
    <v-btn
      fab
      bottom
      left
      color="pink"
      dark
      fixed
      @click="create"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-card-title v-if="update">
          Zmena používateľa
        </v-card-title>
        <v-card-title v-else>
          Nový používateľ
        </v-card-title>

        <v-container grid-list-sm>
          <v-layout wrap>
            <v-flex xs12>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="new_item.username"
                    label="Prihlasovacie meno"
                    required
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="new_item.email"
                    label="Email"
                    :rules="emailRules"
                    required
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="new_item.first_name"
                    label="Meno"
                    required
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="new_item.last_name"
                    label="Priezvisko"
                    required
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="new_item.institution"
                    item-text="name"
                    item-value="id"
                    placeholder="Ústav"
                    label="Ústav"
                    :items="institutions"
                    auto-select-first
                    :search-input.sync="search"
                    cache-items
                    :loading="loading_institutions"
                    hide-no-data
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="new_item.type"
                    placeholder="Typ"
                    label="Typ"
                    :items="selects.types"
                    required
                  />
                </v-col>

                <v-col
                  v-if="update"
                  cols="12"
                  sm="6"
                >
                  <v-checkbox
                    v-model="new_item.is_active"
                    placeholder="Aktívny (používateľ sa môže prihlásiť do systému"
                    label="Aktívny (používateľ sa môže prihlásiť do systému"
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="new_item.password"
                    label="Heslo"
                    autocomplete="new-password"
                    :rules="passwordRules"
                    :append-icon="value ? 'mdi-eye' : 'mdi-account-key'"
                    :type="value ? 'password' : 'text'"
                    @click:append="() => (value = !value)"
                  />
                </v-col>
              </v-row>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn
            text
            color="primary"
            @click="
              dialog = false;
              update = false;
            "
          >
            Zrušiť
          </v-btn>

          <v-btn
            v-if="update"
            text
            @click="updateItem"
          >
            Zmeniť
          </v-btn>
          <v-btn
            v-else
            text
            @click="createItem"
          >
            Vytvoriť
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar_success"
      color="success"
      :timeout="3000"
    >
      Vytvorené
      <v-btn
        text
        @click="snackbar_success = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { APIService } from "@/http/APIService.js";
import auth from "@/api/auth";

const apiService = new APIService();

export default {
  data: () => ({
    my_only: true,
    timeout: null,
    user_pk: "",
    dialog: false,
    update: false,
    loading: true,
    loading_institutions: false,
    snackbar_success: false,

    search_form: "",
    search: null,
    totalItems: 0,
    options: {},
    value: true,


    emailRules: [(v) => /.+@.+/.test(v) || "Emailová adresa má zlý tvar"],
    passwordRules: [
      (v) => v.length >= 8 || "Heslo musí mať minimálne 8 znakov",
    ],

    headers: [
      { text: "Interné ID", value: "id" },
      { text: "Prihlasovacie meno", value: "username" },
      { text: "Meno", value: "first_name" },
      { text: "Priezvisko", value: "last_name" },
      { text: "Email", value: "email" },
      { text: "Typ", value: "type" },
      { text: "Ústav", value: "institution_full.name" },
      { text: "Aktívny", value: "is_active" },
      { text: "Akcie", value: "action", sortable: false },
    ],
    selects: {
      types: [
        "ŠNN",
        "Sociálny pracovník",
        "Pedagóg",
        "Psychológ",
        "PBS",
        "Prípadový manažér",
        "Sociálny kurátor",
        "Lektor",
        "SP - Sociálny podnik",
        "SP - Regionálne centrum",
        "ÚPSVaR - administrátor",
        "ÚPSVaR - spracovateľ",
      ],
    },
    new_item: {
      username: "",
      email: "",
      first_name: "",
      last_name: "",
      institution: "",
      type: "",
      password: "",
      is_active: true,
    },

    institutions: [],
    items: [],
  }),

  watch: {
    search(val) {
      val && this.querySelections(val);
    },
    search_form() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.getDataFromApi();
      }, 500);
    },
    my_only() {
      this.getDataFromApi();
    },

    options: {
      handler() {
        this.getDataFromApi();
      },
    },
    deep: true,
  },

  created() {
    // this.querySelections("");
    auth.getAccountDetails().then((response) => {
      this.user_pk = response.data.pk;
    });
  },

  methods: {
    historyItem(item) {
      this.$router.push({ name: "users_history", params: { id: item.id } });
    },
    editItem(item) {
      this.new_item = Object.assign({}, item);
      this.dialog = true;
      this.update = true;
    },
    create() {
      this.dialog = true;
      this.update = false;

      this.new_item.username = "";
      this.new_item.email = "";
      this.new_item.first_name = "";
      this.new_item.last_name = "";
      this.new_item.institution = "";
      this.new_item.type = "";
      this.new_item.password = "";
      this.is_active = true;
    },

    getUsers(sort, search, limit, offset) {
      this.loading = true;
      if (this.my_only) {
        apiService.getUsersOwn(sort, search, limit, offset).then((response) => {
          this.items = response.results;
          this.totalItems = response.count;
          this.loading = false;
        });
      } else {
        apiService.getUsers(sort, search, limit, offset).then((response) => {
          this.items = response.results;
          this.totalItems = response.count;
          this.loading = false;
        });
      }
    },

    updateItem() {
      if (this.new_item.password == "") delete this.new_item.password;

      apiService.updateUser(this.new_item).then(
        () => {
          this.snackbar_success = true;
          this.getDataFromApi();

          this.new_item.username = "";
          this.new_item.email = "";
          this.new_item.first_name = "";
          this.new_item.last_name = "";
          this.new_item.institution = "";
          this.new_item.type = "";
          this.new_item.password = "";

          this.dialog = false;
          this.update = false;
        },
      );
    },

    createItem() {
      apiService.createUser(this.new_item).then(
        () => {
          this.snackbar_success = true;
          this.getDataFromApi();

          this.new_item.username = "";
          this.new_item.email = "";
          this.new_item.first_name = "";
          this.new_item.last_name = "";
          this.new_item.institution = "";
          this.new_item.type = "";
          this.new_item.password = "";

          this.dialog = false;
        },
      );
    },

    querySelections(v) {
      this.loading_institutions = true;

      apiService.searchInstitutions(v).then((response) => {
        this.institutions = response.results;
        this.loading_institutions = false;
      });
    },

    getDataFromApi() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let sort = "";
      if (sortBy) {
        if (sortBy.length === 1 && sortDesc.length === 1) {
          sort = sortBy[0]
            .replace(/\./g, "__")
            .replace("prisoner_full", "prisoner")
            .replace("institution_full", "institution");
          if (!sortDesc[0]) sort = "-" + sort;
        }
      }

      let offset = "";
      if (itemsPerPage > 0) {
        offset = (page - 1) * itemsPerPage;
      }

      this.getUsers(sort, this.search_form, itemsPerPage, offset);
    },
  },
};
</script> 